import { Event } from 'pages/event'
import { ImageGallery } from 'pages/image-gallery'
import { Profile } from 'pages/profile'
// import {ResetPassword} from 'pages/resetPassword'
export const routes = [
  {
    path: '/',
    component: Event,
    isPrivate: false,
  },
  {
    path: '/profile',
    component: Profile,
    isPrivate: true,
  },
  {
    path: '/image-gallery',
    component: ImageGallery,
    isPrivate: false,
  },
  // {
  //   path: '/reset-password/:id',
  //   component: ResetPassword,
  //   isPrivate: false,
  // },
]
